"use client"

import { useEffect, useRef } from "react"

// Beacon de visualização: dispara 1x por sessão de navegador por aeronave.
//
//  - sessionStorage (`av_view_<id>`) faz o dedupe por sessão — F5/re-render
//    na mesma aba não conta de novo; fechar a aba zera (nova sessão conta).
//  - useRef guarda contra o double-invoke do useEffect em React StrictMode
//    (dev) — em prod o efeito roda uma vez só, mas o ref é barato.
//  - fetch fire-and-forget com keepalive: o POST sobrevive mesmo se o usuário
//    navegar para fora logo após montar. Erros são engolidos de propósito —
//    a contagem nunca pode atrapalhar a navegação.
//  - Renderiza null: é só um efeito colateral montado na página de detalhe.
export function ViewTracker({ aeronaveId }: { aeronaveId: string }) {
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    fired.current = true

    const key = `av_view_${aeronaveId}`
    try {
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, "1")
    } catch {
      // sessionStorage indisponível (modo restrito): segue sem dedupe.
    }

    void fetch(`/api/aeronaves/${aeronaveId}/visualizacoes`, {
      method: "POST",
      keepalive: true,
    }).catch(() => {
      // fire-and-forget
    })
  }, [aeronaveId])

  return null
}
